<input
  type="radio"
  [id]="id"
  name="radio-group"
  [value]="value"
  [disabled]="disabled"
  [checked]="checked"
/>
<label [for]="id">{{ title }}</label>
